// Normalize API errors into a displayable string for per-page handling
export const parseErrorMessage = (err: unknown, fallback = 'Something went wrong. Please try again.') => {
  const data = (err as any)?.data ?? (err as any)
  const message = data?.message ?? data?.error ?? (err as any)?.error ?? (err as any)?.message

  if (!message) return fallback
  if (typeof message === 'string') return message
  if (Array.isArray(message)) {
    const first = message[0]
    if (typeof first === 'string') return first
    if (first?.message) return first.message
    return (
      message
        .map((item) => (typeof item === 'string' ? item : item?.message))
        .filter(Boolean)
        .join(', ') || fallback
    )
  }
  if (typeof message === 'object' && message.message) return message.message
  return fallback
}
